import { Delete, Download, Notify, Log, LogData } from "./views";

const Module = {
    name: "wizards",
    defaultRoutePath: "/wizards",

    routes: [
        //
    ],
    drawerRoutes: [
        {
            path: "delete",
            Component: Delete,
        },
        {
            path: "download",
            Component: Download,
        },
        {
            path: "notify",
            Component: Notify,
        },
        {
            path: "log",
            Component: Log,
        },
        {
            path: "logData",
            Component: LogData,
        },
    ],

}

export default Module;

